<template>
<v-app>

          
  <v-card flat class="mt-15">
    <v-card-text class="text-center black--text headline">
      Click the link below to go to the enrolment page.
    </v-card-text>
    <v-card-text class="text-center blue--text headline">
        <a target="_blank" href="https://form.bondibasc.com/">https://form.bondibasc.com/</a>
    </v-card-text>
    <v-card-text class="text-center black--text headline">
        Then select 'Enrol' to begin a new enrolment or edit an existing one.
      </v-card-text>
   </v-card>
    
    
</v-app>
</template>

<script>
import db from "@/fb";
import { getAuth, signOut } from "firebase/auth";
import { doc, collection, addDoc, updateDoc, } from "firebase/firestore";
// import { format } from 'date-fns';
import { getStorage, ref, getDownloadURL, uploadString  } from "firebase/storage";

export default {
  
  name: 'App',
  metaInfo: {
      title: 'Enrol',
      titleTemplate: '%s | BASC',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },
  data: () => ({
     // start signatures
       processing: false,
      dialogSignature: false,
      signature: '',
      hideMessage: true,
      hideMessage1: true,
      signatureClass: 'blue lighten-5',
      saveColour: 'green',
      signUpDate: null,
      saveSignature: false,
          // start signature props
          currentCollection: null,
          currentDocument: null,
          currentKey: null,
      // end signature
    search: '',
    // tabs
    tabs: null,
    tabItems: [
      {
        title: 'ACC', icon: 'mdi-account', route: '/',
      },
      {
        title: 'Child', icon: 'mdi-human-child', route: '/children',
      },
      {
        title: 'Book', icon: 'mdi-calendar', route: '/bookings',
      },
      {
        title: 'Contacts', icon: 'mdi-account-box', route: '/contacts',
      },
      ],
    // end tabs
    loading: false,
    // user info
    //snackbar
    snackbar: false,
    snackbarColour: '',
    snackbarTitle: '',
    snackbarMessage: '',
    componentKey: 0,
      isLoggedIn: false,
      userId: null,
      userEmail: null,
  }),
  created: function() {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (user !== null) {
   
        this.isLoggedIn = true;
        this.userId = user.uid
        //this.accountId = user.displayName
        // this.userData = user;
        this.userEmail = user.email;
    }
    else {
        this.isLoggedIn = false;
        this.userData = null;
      }
  },
  methods: {
    // start signature
    signatureSet(collection, document, key) {
        this.currentCollection = collection
        this.currentDocument = document
        this.currentKey = key
        this.dialogSignature = true
     },
     undo() {
      this.$refs.signaturePad.undoSignature();
      this.signature = ''
    },
    clear() {
      this.$refs.signaturePad.clearSignature()
      this.signature = ''
    },
    async updateSignature () {
      var vm = this
       const { data } = this.$refs.signaturePad.saveSignature('image/png'); 
      if (data === undefined)
      {return this.signatureClass = 'red lighten-4', this.saveColour = 'red', this.hideMessage1 = false}
          else {
       this.processing = true
       const filePath = `signatures/${new Date()}`;
            const storage = getStorage();
             const metadata = {
              contentType: 'image/jpeg',
            };
            const storageRef = ref(storage, filePath, metadata);
          await uploadString(storageRef, data, 'data_url').then(async (snapshot) => {
             getDownloadURL(snapshot.ref).then( async (downloadURL) => {
                // this.photos.push(downloadURL)
                
                const info = {
                  [vm.currentKey]: downloadURL
                }
                const docRef = doc(db, vm.currentCollection, vm.currentDocument)
            await updateDoc(docRef, info)
          
          })
     })
      .then(async ()=> {
      this.signatureClass = 'green lighten-4'
      this.hideMessage = true
      vm.processing = false
      vm.dialogSignature = false
      vm.signatureClass = 'blue lighten-5'
      vm.hideMessage = true
      vm.saveColour = 'green'
      vm.clear()
      vm.snackbarSet('green', 'Success', 'Signature Updated!')
      })
          }
      
    },
    // end signauter
    // start firebase general methods
      async updateDocument(colRef, documentRef, updateRef, snackbarMessage){
      const docRef = doc(db, colRef, documentRef)
      await updateDoc(docRef, updateRef)
       if (snackbarMessage === null)
      {return}
      else {
      this.snackbarSet('green', 'Success', snackbarMessage)
      }
    },
    async addDocument(colRef, addRef, snackbarMessage){
      await addDoc(collection(db, colRef), addRef)
      if (snackbarMessage === null)
      {return}
      else {
      this.snackbarSet('green', 'Success', snackbarMessage)
      }
    },
    // end firebase gneral methods
    snackbarSet(colour, title, nessage) {
        this.snackbarColour = colour
        this.snackbarTitle = title
        this.snackbarMessage = nessage
        this.snackbar = true
    },
    homeRefresh () {
      this.goHome()
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1;  
    },
    goHome () {
      this.$router.replace('/')
    },
    goToLogin () {
      this.$router.replace('/login')
    },
    newForm () {
      this.$router.replace('/select-form')
    },
    logout: function() {
      const auth = getAuth();
      signOut(auth).then(() => {
        this.$router.go({ path: this.$router.path });
          this.$router.go()
      }).catch((error) => {
        alert(error)
      });
    },
  }
  
};
</script>

<style>


.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}


</style>


